import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Hooks/AuthContext";
import NavDrawer from "../../Pages/NavDrawer/NavDrawer";
import useIsDesktop from "../../Hooks/useIsDesktop";

// Fired (cancelable) to open the nav drawer on its login, e.g. by a guest's
// "Log in to save" link. A mounted drawer answers with preventDefault, so the
// sender knows whether this page has one (search doesn't) and can fall back.
export const OPEN_LOGIN_DRAWER = "wc:open-login-drawer";

const CustomDrawer = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  // Opened to log in (not to browse): the phone box takes focus once the
  // slide-in has finished (afterOpenChange) -- antd focuses its own panel on
  // open, so focusing any earlier gets taken back on a slow page.
  const [forLogin, setForLogin] = useState(false);
  const [focusLoginTick, setFocusLoginTick] = useState(0);
  const user_name = localStorage.getItem("name");
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setLoggedIn(!!user?.number);
  }, [user]);

  // Opened on arrival when a page sends { openNavDrawer: true } -- e.g. a
  // guest tapping a wishlist heart is brought home with the drawer open, where
  // its login lives. The flag is cleared at once so refresh/back don't reopen.
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!location.state?.openNavDrawer) return;
    setForLogin(true);
    setOpen(true);
    navigate(`${location.pathname}${location.search}`, {
      replace: true,
      state: null,
    });
  }, [location.state, location.pathname, location.search, navigate]);

  useEffect(() => {
    const onOpenLogin = (e) => {
      if (e.defaultPrevented) return; // another drawer already took it
      e.preventDefault();
      setForLogin(true);
      setOpen(true);
    };
    window.addEventListener(OPEN_LOGIN_DRAWER, onOpenLogin);
    return () => window.removeEventListener(OPEN_LOGIN_DRAWER, onOpenLogin);
  }, []);

  const close = () => {
    setOpen(false);
    setForLogin(false);
  };

  return (
    <>
      {/* Design store-header menu — asymmetric two-line hamburger, 22px, ink-900. */}
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        onClick={() => setOpen(true)}
        className="w-[22px] h-[22px] text-ink-900 cursor-pointer"
      >
        <line x1="3" y1="7" x2="21" y2="7" />
        <line x1="3" y1="14" x2="14" y2="14" />
      </svg>
      <Drawer
        placement="left"
        closable={false}
        onClose={close}
        open={open}
        afterOpenChange={(isOpen) => {
          if (isOpen && forLogin) setFocusLoginTick((n) => n + 1);
        }}
        key="left"
        // Drawer portals to <body> and sizes off the viewport, not the app's
        // centered column — so 90% is ~360px on mobile but ~1300px on desktop.
        // Cap to a normal side-panel width once we're past the lg breakpoint.
        width={isDesktop ? 380 : "90%"}
        styles={{ body: { padding: 0 } }}
      >
        <NavDrawer
          loggedIn={loggedIn}
          name={user_name}
          number={user?.number}
          open={open}
          focusLoginTick={focusLoginTick}
          onClose={close}
          onLogout={() => {
            close();
            logout();
          }}
        />
      </Drawer>
    </>
  );
};
export default CustomDrawer;
